<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{'Accounting Department Data' | translate }}</h1>
      <p>{{'Enter Contacts Category' | translate }}</p>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Contacts Category' | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 100px;">{{ 'Code' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()"></span>
            <input type="text" name="clsscSerial"  style="width: 152px;" [(ngModel)]="catCode" (change)="retriveCategory()">
          </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Name' | translate }}</label>
          <input type="text" name="classname" style="width: 500px;" [(ngModel)]="catName" >
        </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Arabic Name' | translate }}</label>
          <input type="text" name="classaname"  style="width: 500px;" [(ngModel)]="catNotes" >
        </div>

    </form>
  </div>
  </div>
</div>
<BR>
<BR>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="submit" (click)="submitCategory()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="MesgDelete()">{{ 'Delete' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
    <a href="Home">
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
    <BR>

</section>



